import { render, staticRenderFns } from "./RemittanceNeopag.vue?vue&type=template&id=146d846a&scoped=true&"
import script from "./RemittanceNeopag.vue?vue&type=script&lang=js&"
export * from "./RemittanceNeopag.vue?vue&type=script&lang=js&"
import style0 from "./RemittanceNeopag.vue?vue&type=style&index=0&id=146d846a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d846a",
  null
  
)

export default component.exports